// Google Ads Service - UŻYWA PRAWDZIWEGO API!
import { googleAdsRealService } from './googleAdsRealService';
import {
  AdCampaign,
  AdGroup,
  Ad,
  Keyword,
  CampaignStats,
  KeywordResearch,
  BudgetRecommendation,
  CampaignOptimization
} from '../types/googleAds.types';

// PRZEKIEROWANIE NA PRAWDZIWE API
export class GoogleAdsService {
  constructor() {
    console.log('🚀 Google Ads Service initialized');
    console.log('📍 API URL: https://api.plexisystem.pl/api/ads');
  }

  // Kampanie - UŻYWA PRAWDZIWEGO API
  async createCampaign(campaign: Omit<AdCampaign, 'id' | 'created_at' | 'updated_at'>): Promise<AdCampaign> {
    console.log('🚀 Creating campaign via REAL API');
    return googleAdsRealService.createCampaign(campaign);
  }

  async updateCampaign(id: string, updates: Partial<AdCampaign>): Promise<AdCampaign> {
    console.log('🔄 Updating campaign via REAL API');
    return googleAdsRealService.updateCampaign(id, updates);
  }

  async getCampaigns(filters?: {
    status?: string;
    type?: string;
  }): Promise<AdCampaign[]> {
    console.log('📊 Fetching campaigns from REAL Google Ads API');
    return googleAdsRealService.getCampaigns(filters);
  }

  async getCampaign(id: string): Promise<AdCampaign> {
    return googleAdsRealService.getCampaign(id);
  }

  async deleteCampaign(id: string): Promise<void> {
    return googleAdsRealService.deleteCampaign(id);
  }

  // Grupy reklam - przekieruj na REAL API
  async createAdGroup(adGroup: Omit<AdGroup, 'id' | 'created_at'>): Promise<AdGroup> {
    return googleAdsRealService.createAdGroup(adGroup);
  }

  async updateAdGroup(id: string, updates: Partial<AdGroup>): Promise<AdGroup> {
    return googleAdsRealService.updateAdGroup(id, updates);
  }

  async getAdGroups(campaignId: string): Promise<AdGroup[]> {
    return googleAdsRealService.getAdGroups(campaignId);
  }

  // Reklamy - przekieruj na REAL API
  async createAd(ad: Omit<Ad, 'id' | 'created_at'>): Promise<Ad> {
    return googleAdsRealService.createAd(ad);
  }

  async updateAd(id: string, updates: Partial<Ad>): Promise<Ad> {
    return googleAdsRealService.updateAd(id, updates);
  }

  async getAds(adGroupId: string): Promise<Ad[]> {
    return googleAdsRealService.getAds(adGroupId);
  }

  async deleteAd(id: string): Promise<void> {
    return googleAdsRealService.deleteAd(id);
  }

  // Słowa kluczowe - przekieruj na REAL API
  async addKeywords(keywords: Omit<Keyword, 'id'>[]): Promise<Keyword[]> {
    return googleAdsRealService.addKeywords(keywords);
  }

  async updateKeyword(id: string, updates: Partial<Keyword>): Promise<Keyword> {
    return googleAdsRealService.updateKeyword(id, updates);
  }

  async getKeywords(adGroupId: string): Promise<Keyword[]> {
    return googleAdsRealService.getKeywords(adGroupId);
  }

  // Statystyki - przekieruj na REAL API
  async getCampaignStats(campaignId: string, dateFrom: Date, dateTo: Date): Promise<CampaignStats[]> {
    return googleAdsRealService.getCampaignStats(campaignId, dateFrom, dateTo);
  }

  async getAggregatedStats(campaignIds: string[], dateFrom: Date, dateTo: Date): Promise<{
    totalImpressions: number;
    totalClicks: number;
    totalCost: number;
    totalConversions: number;
    avgCtr: number;
    avgCpc: number;
    roas: number;
  }> {
    return googleAdsRealService.getAggregatedStats(campaignIds, dateFrom, dateTo);
  }

  // Badanie słów kluczowych - przekieruj na REAL API
  async researchKeywords(seedKeywords: string[]): Promise<KeywordResearch[]> {
    return googleAdsRealService.researchKeywords(seedKeywords);
  }

  // Rekomendacje budżetu - przekieruj na REAL API
  async getBudgetRecommendation(
    keywords: string[],
    targetLocation: string,
    monthlyBudget: number
  ): Promise<BudgetRecommendation> {
    return googleAdsRealService.getBudgetRecommendation(keywords, targetLocation, monthlyBudget);
  }

  // Optymalizacja kampanii - przekieruj na REAL API
  async getCampaignOptimizations(campaignId: string): Promise<CampaignOptimization> {
    return googleAdsRealService.getCampaignOptimizations(campaignId);
  }

  // Eksport kampanii - przekieruj na REAL API
  async exportCampaigns(campaignIds: string[], format: 'csv' | 'xlsx'): Promise<Blob> {
    return googleAdsRealService.exportCampaigns(campaignIds, format);
  }
}

export const googleAdsService = new GoogleAdsService();
